<template>
    <installment-price  
        :class="[
            (product_modal || product_page || related || page_wish_list) ? 'text-left' : 'text-center'
        ]" 
    >
        {{interestFreeInstallments()}}
    </installment-price>
</template>

<script>
import {getInterestFreeInstallments} from '../../services/product'
import {mapGetters, mapState} from 'vuex'
import { CInstallmentPrice } from '../Styles/Product/styled';

export default {
    name: 'InterestFreeInstallments',
    components: {
        'installment-price': CInstallmentPrice
    },
    props: {
        item: {
            required: true, 
            type: Object
        },
        product_page: {
            default: false, 
            type: Boolean,
        },
        product_modal: {
            default: false, 
            type: Boolean,
        },
        related: {
            default: false
        },
        page_wish_list: { default: false }
    },
    methods: {
        interestFreeInstallments() {
            return getInterestFreeInstallments(this.item, this.company, this.getTotalPriceAdditionalItemsSelected, this.getFlavorsSelected, this.quantityFractional, this.product_page, this.product_modal)
        }
    },
    computed: {
        ...mapState("company", [
            "company"
        ]),
        ...mapState("products", ["quantityFractional"]),
        ...mapGetters("products", [
            "getTotalPriceAdditionalItemsSelected",
            "getFlavorsSelected"
        ])
    },
    watch: {
        getTotalPriceAdditionalItemsSelected() {
            this.interestFreeInstallments()
        }
    }
}
</script>

<style>

</style>